/**
 * Action types
 */
export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_TRACKING = 'SET_TRACKING'
export const SET_CURRENCY = 'SET_CURRENCY'
export const SET_INCOGNITO = 'SET_INCOGNITO'
